import { action, makeAutoObservable } from "mobx";
import { RootStore } from "../index";
import BasketModel from "../../model/BasketModel";
import DeliveryModel from "../../model/DeliveryModel";
import PaymentModel from "../../model/PaymentModel";
import OrderModel from "../../model/OrderModel";
import {
  APP_DELIVERY_CODE_AUTO_EXPORT,
  APP_DELIVERY_CODE_SELF_EXPORT,
} from "../../const/root";
import { enumOrderStatus } from "../../enum/enumOrderStatus";
import { uuidv4 } from "../../helper/uid";
import s3Model from "../../model/s3Model";

export class PageBasketStore {
  private rootStore: RootStore | undefined;

  arItems = [];
  files = [];
  showBtnSend = true;

  selectedOption = {
    DeliveryType: { value: 0, label: "Условия доставки" },
    DeliverySelf: { value: 0, label: "Условия самовывоза" },
    DeliveryInvoices: { value: 1, label: "ТН" },
    Payment: { value: 0, label: "Тип оплаты" },
    PaymentType: { value: 0, label: "Условия оплаты" },
    Dates: { value: 0, label: "Дата доставки" },
    Points: { value: 0, label: "Адрес доставки", amount: 0 },
  };

  selectedOptionDefault = {
    DeliveryType: { value: 0, label: "Условия доставки" },
    DeliverySelf: { value: 0, label: "Условия самовывоза" },
    DeliveryInvoices: { value: 0, label: "Накладные" },
    Payment: { value: 0, label: "Тип оплаты" },
    PaymentType: { value: 0, label: "Условия оплаты" },
    Dates: { value: 0, label: "Дата доставки" },
    Points: { value: 0, label: "Адрес доставки", amount: 0 },
  };

  isModalOpen = false;
  isModalOpen2 = false;
  isModalOpen3 = false;
  isDeliveryTypeSelf = false;
  isDropzone = false;
  pickupFileLink: null | string = null;
  pickupType: null | string = null;

  setSelectedOption = {
    DeliveryType: (e: any) => {},
    DeliverySelf: (e: any) => {},
    DeliveryInvoices: (e: any) => {},
    Payment: (e: any) => {},
    PaymentType: (e: any) => {},
    Dates: (e: any) => {},
    Points: (e: any) => {},
  };

  options: Record<string, any[]> = {
    DeliveryType: [],
    DeliverySelf: [
      { value: 1, label: "Печать" },
      { value: 2, label: "Доверенность" },
    ],
    DeliveryInvoices: [],
    Payment: [],
    PaymentType: [],
    Dates: [],
    Points: [],
  };

  summAll = 0;
  paymentTypeForWebPay = 0;
  linkWebPay = "";
  openWebPayModalWindow = false;
  openWebPayModalWindowAboutRedirect = false;
  textAboutErrorWebPayLink = false;
  openWebPayModalWindowAboutTotalSum = false;
  futureScores = 0;
  scores = 0;
  showMessageAboutBlockAction = false;
  scoresConst = 0;

  constructor(rootStore?: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;

    this.setSelectedOption = {
      DeliveryType: this.setSelectedOptionDeliveryType,
      DeliverySelf: this.setSelectedOptionDeliverySelf,
      DeliveryInvoices: this.setSelectedOptionDeliveryInvoices,
      Payment: this.setSelectedOptionPayment,
      PaymentType: this.setSelectedOptionPaymentType,
      Dates: this.setSelectedOptionDates,
      Points: this.setSelectedOptionPoints,
    };
  }

  @action init() {
    this.linkWebPay = "";
    this.isModalOpen = false;
    if (
      !this.selectedOption.DeliveryType.value &&
      !this.selectedOption.Points.value &&
      !this.selectedOption.Dates.value &&
      !this.selectedOption.PaymentType.value
    ) {
      this.reload();
    }
  }

  @action reload() {
    this.linkWebPay = "";
    let clientId = this.rootStore?.mainStore.getClientId();

    if (this.rootStore?.mainStore.user.siteId === 3) {
      this.defaultDate();
      DeliveryModel.getDates(
        0,
        APP_DELIVERY_CODE_SELF_EXPORT,
        this.setDates,
        this.setError
      );
    }

    PaymentModel.getTypes(clientId, this.setPaymentType, this.setError);
    DeliveryModel.getTypes(0, this.setDeliveryType, this.setError);
    
    // Для siteId === 3 не загружаем точки доставки, так как используется самовывоз
    if (this.rootStore?.mainStore.user?.siteId !== 3) {
      DeliveryModel.getPoints(clientId, this.getPoints, this.setError);
    }
    
    DeliveryModel.getAccountability(this.getAccountability, this.setError);
  }

  @action initMain = () => {
    // Устанавливаем DeliveryType по умолчанию как самовывоз для siteId === 3
    const defaultDeliveryType = this.rootStore?.mainStore.user?.siteId === 3 
      ? { value: APP_DELIVERY_CODE_SELF_EXPORT, label: "Самовывоз" }
      : { value: 0, label: "Условия доставки" };

    // Для siteId === 3 и самовывоза устанавливаем Points.value = 43982
    const defaultPoints = this.rootStore?.mainStore.user?.siteId === 3 && defaultDeliveryType.value === APP_DELIVERY_CODE_SELF_EXPORT
      ? { value: 43982, label: "Самовывоз", amount: 0 }
      : { value: 0, label: "Адрес доставки", amount: 0 };

    this.selectedOption = {
      DeliveryType: defaultDeliveryType,
      DeliverySelf: { value: 0, label: "Условия самовывоза" },
      DeliveryInvoices: { value: 1, label: "ТН" },
      Payment: { value: 0, label: "Тип оплаты" },
      PaymentType: { value: 0, label: "Условия оплаты" },
      Dates: { value: 0, label: "Дата доставки" },
      Points: defaultPoints,
    };

    this.selectedOptionDefault = {
      DeliveryType: defaultDeliveryType,
      DeliverySelf: { value: 0, label: "Условия самовывоза" },
      DeliveryInvoices: { value: 1, label: "ТН" },
      Payment: { value: 0, label: "Тип оплаты" },
      PaymentType: { value: 0, label: "Условия оплаты" },
      Dates: { value: 0, label: "Дата доставки" },
      Points: defaultPoints,
    };

    this.isModalOpen = false;

    this.options = {
      DeliveryType: [],
      DeliverySelf: [
        { value: 1, label: "Печать" },
        { value: 2, label: "Доверенность" },
      ],
      DeliveryInvoices: [],
      Payment: [],
      PaymentType: [],
      Dates: [],
      Points: [],
    };
    this.reload();
  };

  setSelectedOptionDeliveryType = (e: any) => {
    this.isDeliveryTypeSelf = false;
    this.selectedOption.DeliveryType = e;
    let clientId = this.rootStore?.mainStore.getClientId();

    if (e.value === APP_DELIVERY_CODE_SELF_EXPORT) {
      this.isDeliveryTypeSelf = true;
      this.defaultDate();
      DeliveryModel.getDates(
        0,
        APP_DELIVERY_CODE_SELF_EXPORT,
        this.setDates,
        this.setError
      );
      
      // Для siteId === 3 и самовывоза автоматически устанавливаем Points.value = 43982
      if (this.rootStore?.mainStore.user?.siteId === 3) {
        this.selectedOption.Points = { value: 43982, label: "Самовывоз", amount: 0 };
      }
    }

    if (e.value === APP_DELIVERY_CODE_AUTO_EXPORT) {
      DeliveryModel.getPoints(clientId, this.getPoints, this.setError);
    }
  };

  setSelectedOptionDeliverySelf = (e: any) => {
    this.isDropzone = false;
    this.selectedOption.DeliverySelf = e;
    if (e.value === 2) {
      this.isDropzone = true;
    }

    switch (e.value) {
      case 1:
        this.pickupType = "печать";
        break;
      case 2:
        this.pickupType = "доверенность";
        break;
      default:
        this.pickupType = null;
        break;
    }
  };

  setSelectedOptionDeliveryInvoices = (e: any) => {
    this.selectedOption.DeliveryInvoices = e;
  };

  defaultDate() {
    this.selectedOption.Dates = { value: 0, label: "Выберите дату" };
    this.options.Dates = [];
  }

  setSelectedOptionPaymentType = (e: any) => {
    if (e.value === 7) {
      this.paymentTypeForWebPay = 7;
    }
    this.selectedOption.PaymentType = e;
    this.getBasket();
  };

  setSelectedOptionPayment = (e: any) => {
    this.selectedOption.Payment = e;
    this.getBasket();
  };

  setSelectedOptionDates = (e: any) => {
    this.selectedOption.Dates = e;
    if (this.getOpenModal2()) {
      alert(
        "Оформить доставку можно на ближайшие 5 календарных дней, текущий заказ можно сохранить как черновик на сайте"
      );
    }
  };

  @action
  ClearAll = () => {
    let clientId = this.rootStore?.mainStore.getClientId();
    BasketModel.deleteAll(
      { clientId: clientId },
      this.setBasket,
      this.setError
    );
  };
  setSelectedOptionPoints = (e: any, link: boolean = true) => {
    this.selectedOption.Points = e;
    this.defaultDate();
    DeliveryModel.getDates(
      this.selectedOption.Points.value,
      this.selectedOption.DeliveryType.value,
      this.setDates,
      this.setError
    );
    if (link) {
      this.rootStore?.mainStore.onChangeInputTradePoint(e, false);
    }
    if (
      this.selectedOption.DeliveryType.value !== APP_DELIVERY_CODE_AUTO_EXPORT
    ) {
      // @ts-ignore
      this.selectedOption.DeliveryType = this.options.DeliveryType.filter(
        (item: any) => item.value === APP_DELIVERY_CODE_AUTO_EXPORT
      );
    }
  };

  @action
  minusCount = (item: any) => {
    let multiplicity = this.getMultiplicityCount(item);
    if (item.basket.count > multiplicity) {
      item.basket.count -= multiplicity;
      BasketModel.addProduct(
        item.basket,
        this.selectedOption.PaymentType.value,
        this.setBasket,
        this.setError
      );
    }
  };

  @action
  productPlus = (item: any) => {
    let multiplicity = this.getMultiplicityCount(item?.product);
    if (item.isMultiplicity) {
      item.count = this.addCountMultiplicity(item.count, item.multiplicity);
    } else {
      item.count = this.addCountMultiplicity(item.count, multiplicity);
    }
    this.changeProduct(item);
  };

  @action
  productMinus = (item: any) => {
    let multiplicity = this.getMultiplicityCount(item?.product);
    if (item.isMultiplicity) {
      item.count = this.minusCountMultiplicity(item.count, item.multiplicity);
    } else {
      item.count = this.minusCountMultiplicity(item.count, multiplicity);
    }
    this.changeProduct(item);
  };
  @action
  productMinusScores = (minus: number) => {
    if (this.showMessageAboutBlockAction) {
      alert("Данный товар не учавствует в программе лояльности");
    } else {
      let newValue = this.scores;
      if (newValue >= 0.1) {
        this.scores = newValue - minus;
        this.scores = parseFloat(this.scores.toFixed(2));
        let clientId = this.rootStore?.mainStore.getClientId();
        let discount = this.selectedOption?.PaymentType?.value;
        let scores = this.scores;
        BasketModel.getFutureLoyaltyScores(
          clientId,
          discount,
          scores,
          this.setLoyaltyScores,
          this.setError
        );
      } else if (newValue < 0.1 && newValue > 0) {
        this.scores = newValue - 0.01;
        this.scores = parseFloat(this.scores.toFixed(2));
        let clientId = this.rootStore?.mainStore.getClientId();
        let discount = this.selectedOption?.PaymentType?.value;
        let scores = this.scores;
        BasketModel.getFutureLoyaltyScores(
          clientId,
          discount,
          scores,
          this.setLoyaltyScores,
          this.setError
        );
      }
    }
  };

  @action
  productPlusScores = (plus: number) => {
    let newValue = this.scores;
    let plusValue = 0;
    let check = this.scoresConst - newValue;

    if (this.showMessageAboutBlockAction) {
      alert("В корзине отсутствуют товары из каталога бонусных товаров");
    } else {
      if (
        newValue < Number(this.rootStore?.mainStore.scoresAmount) &&
        check > 0.1
      ) {
        plusValue = plus;
      } else {
        plusValue = 0.01;
      }
      if (newValue + plusValue > this.scoresConst) {
        return alert(
          "Максимальное количество бонусов для Вашей корзины " +
            " " +
            this.scoresConst
        );
      }
      // @ts-ignore
      if (newValue < Number(this.rootStore?.mainStore.scoresAmount)) {
        this.scores = newValue + plusValue;
        this.scores = parseFloat(this.scores.toFixed(2));
        let clientId = this.rootStore?.mainStore.getClientId();
        let discount = this.selectedOption?.PaymentType?.value;
        let scores = this.scores;
        BasketModel.getFutureLoyaltyScores(
          clientId,
          discount,
          scores,
          this.setLoyaltyScores,
          this.setError
        );
      }
    }
  };

  @action setMultiplicity = (item: any, isValue: boolean) => {
    item.isMultiplicity = isValue;
    if (isValue) {
      if (item.count < item.multiplicity) {
        item.count = item.multiplicity;
      } else {
        item.count = item.count - (item.count % item.multiplicity);
      }
      this.changeProduct(item);
    }
  };

  @action changeProductInput = (
    e: { target: { value: string } },
    item: any
  ) => {
    let count = parseInt(e.target.value);
    let multiplicity = this.getMultiplicityCount(item?.product);
    if (item.isMultiplicity) {
      item.count = this.roundCountMultiplicity(count, item.multiplicity);
    } else {
      item.count = this.roundCountMultiplicity(count, multiplicity);
    }
    if (item.count === 0 || !item.count) {
      item.count = 1;
    }
    this.changeProduct(item);
  };

  @action changeScoreInput = (e: { target: { value: string } }) => {
    if (this.showMessageAboutBlockAction) {
      alert("Данный товар не учавствует в программе лояльности");
    } else {
      let value = e.target.value;
      if (Number(value) > this.scoresConst) {
        return alert(
          "Максимальное количество бонусов для Вашей корзины " +
            " " +
            this.scoresConst
        );
      }
      if (
        this.rootStore?.mainStore.scoresAmount &&
        Number(value) <= this.rootStore?.mainStore.scoresAmount
      ) {
        this.scores = Number(value);
        let clientId = this.rootStore?.mainStore.getClientId();
        let discount = this.selectedOption?.PaymentType?.value;
        let scores = this.scores;
        BasketModel.getFutureLoyaltyScores(
          clientId,
          discount,
          scores,
          this.setLoyaltyScores,
          this.setError
        );
      } else {
        alert("столько баллов у Вас нет");
      }
    }
  };

  roundCountMultiplicity = (count: number, multiplicity: number) => {
    let result = count;
    if (!count) {
      count = multiplicity;
    }
    if (multiplicity > 1) {
      result = count - (count % multiplicity);
      if (!result) {
        result = multiplicity;
      }
    }
    return result;
  };

  minusCountMultiplicity = (count: number, multiplicity: number) => {
    let result = count - multiplicity;
    if (result < multiplicity) {
      result = multiplicity;
    }
    return result;
  };

  addCountMultiplicity = (count: number, multiplicity: number) => {
    return count + multiplicity;
  };

  @action changeProductInputCatalog = (
    e: { target: { value: string } },
    item: any
  ) => {
    let count = parseInt(e.target.value);
    let multiplicity = this.getMultiplicityCount(item);
    item.basket.count = this.roundCountMultiplicity(count, multiplicity);
    BasketModel.addProduct(
      item.basket,
      this.selectedOption.PaymentType.value,
      this.setBasket,
      this.setError
    );
  };

  setData(
    result: any,
    keyData: string,
    keyName: string,
    keyField: string = ""
  ) {
    this.options[keyData] = [];
    if (result.data?.length) {
      result.data.map((item: any) => {
        if (keyField.length) {
          this.options[keyData].push({
            // @ts-ignore
            value: item?.id,
            // @ts-ignore
            label: item[keyName],
            // @ts-ignore
            [keyField]: item[keyField],
          });
        } else {
          // @ts-ignore
          this.options[keyData].push({
            // @ts-ignore
            value: item?.id,
            // @ts-ignore
            label: item[keyName],
          });
        }
        return item;
      });

      if (keyField.length) {
        // @ts-ignore
        this.selectedOption[keyData] = {
          // @ts-ignore
          value: result.data[0]?.id,
          // @ts-ignore
          label: result.data[0][keyName],
          // @ts-ignore
          [keyField]: result.data[0][keyField],
        };
      } else {
        // @ts-ignore
        this.selectedOption[keyData] = {
          // @ts-ignore
          value: result.data[0]?.id,
          // @ts-ignore
          label: result.data[0][keyName],
        };
      }
    }
  }

  @action
  setDeliveryType = (result: any) => {
    this.setData(result, "DeliveryType", "name");
    
    // Для siteId === 3 устанавливаем самовывоз по умолчанию
    if (this.rootStore?.mainStore.user?.siteId === 3) {
      const selfExportOption = result.data?.find((item: any) => item.id === APP_DELIVERY_CODE_SELF_EXPORT);
      if (selfExportOption) {
        this.selectedOption.DeliveryType = {
          value: selfExportOption.id,
          label: selfExportOption.name
        };
        
        // Устанавливаем флаг самовывоза для скрытия адресов доставки
        this.isDeliveryTypeSelf = true;
        
        // Загружаем даты для самовывоза
        this.defaultDate();
        DeliveryModel.getDates(
          0,
          APP_DELIVERY_CODE_SELF_EXPORT,
          this.setDates,
          this.setError
        );
      }
    }
    
    if (result?.data[0].id) {
      let id = result?.data[0].id;
      PaymentModel.getPayments(id, this.setPayment, this.setError);
    }
  };
  @action
  setDates = (result: any) => {
    this.setData(result, "Dates", "name");
  };
  @action
  getPoints = (result: any) => {
    this.setData(result, "Points", "name", "amount");
    // Сбрасываем даты перед загрузкой новых
    this.defaultDate();
    // Загружаем даты для первого Point в списке
    if (result.data?.length && result.data[0]?.id) {
      DeliveryModel.getDates(
        result.data[0].id,
        this.selectedOption.DeliveryType.value,
        this.setDates,
        this.setError
      );
    }
  };

  @action
  getAccountability=(result: any) =>{
    this.setData(result, "DeliveryInvoices", "docName");
  }

  @action
  setPaymentType = (result: any) => {
    this.setData(result, "PaymentType", "name");
    this.getBasket();
  };

  @action
  setPayment = (result: any) => {
    this.setData(result, "Payment", "name");
  };

  @action
  getBasket() {
    this.futureScores = 0;
    let clientId = this.rootStore?.mainStore.getClientId();
    let discount = this.selectedOption?.PaymentType?.value;
    let scores = this.scores;
    BasketModel.getFutureLoyaltyScores(
      clientId,
      discount,
      scores,
      this.setLoyaltyScores,
      this.setError
    );
    BasketModel.getBasket(clientId, discount, this.setBasket, this.setError);
    // BasketModel.getFutureLoyaltyScores(clientId, discount, this.setBasket, this.setError)
  }

  @action
  addCount = (item: any) => {
    let multiplicity = this.getMultiplicityCount(item);
    item.basket.count += multiplicity;
    BasketModel.addProduct(
      item.basket,
      this.selectedOption.PaymentType.value,
      this.setBasket,
      this.setError
    );
  };

  @action
  addProduct = (item: any) => {
    let multiplicity = this.getMultiplicityCount(item);
    if (!item.basket.count) {
      item.basket.count = multiplicity;
    }
    BasketModel.addProduct(
      item.basket,
      this.selectedOption.PaymentType.value,
      this.setBasket,
      this.setError
    );
  };

  @action
  changeProduct = (item: any) => {
    BasketModel.addProduct(
      item,
      this.selectedOption.PaymentType.value,
      this.setBasket,
      this.setError
    );
  };

  @action
  productDelete = (item: any) => {
    const clientId = this.rootStore?.mainStore.getClientId();
    // @ts-ignore
    BasketModel.deleteProduct(
      {
        id: item.id,
        clientId: clientId,
        // @ts-ignore
        discount: this.selectedOption.PaymentType?.value,
      },
      this.setBasket,
      this.setError
    );
  };

  @action
  setBasket = (result: any) => {
    this.scoresConst = 0;
    this.scores = 0;
    this.summAll = 0;
    this.showBtnSend = true;
    this.showMessageAboutBlockAction = false;
    if (result.data) {
      result.data.map((item: any) => {
        if (item?.product?.price?.final_price) {
          item.product.price.final_price = parseFloat(
            item?.product?.price?.final_price
          ).toFixed(2);
          let vat = parseFloat(item?.product?.propsNoFilter?.vat);
          let price = parseFloat(item?.product?.price?.final_price);
          let count = parseFloat(item.count);
          let Summ = parseFloat((count * price).toFixed(2));
          let Nds = parseFloat(((Summ * vat) / 100).toFixed(2));
          let SummNds = parseFloat((Summ + Nds).toFixed(2));
          let maxScoresForItem = parseFloat(item?.product?.price?.max_scores);
          item.product.price["Summ"] = Summ;
          item.product.price["Nds"] = Nds;
          item.product.price["SummNds"] = SummNds;
          this.summAll += SummNds;

          item["isMultiplicity"] = !!item.isMultiplicity;
          item["multiplicity"] = item?.product?.propsNoFilter?.inBox;
          item.count = parseFloat(item.count);
          this.scores += count * maxScoresForItem;
          this.scoresConst += count * maxScoresForItem;
          this.scoresConst = parseFloat(this.scoresConst.toFixed(2));

          if (
            this.showBtnSend &&
            item.count > item?.product?.stocks[0]?.amount
          ) {
            this.showBtnSend = false;
          }
        } else {
          this.showBtnSend = false;
        }
        return item;
      });
      this.summAll = parseFloat(this.summAll.toFixed(2));
      this.scores = parseFloat(this.scores.toFixed(2));

      // @ts-ignore
      if (this.rootStore?.mainStore.scoresAmount < this.scores) {
        this.scores = Number(this.rootStore?.mainStore.scoresAmount);
      }
      let clientId = this.rootStore?.mainStore.getClientId();
      let discount = this.selectedOption?.PaymentType?.value;
      let scores = this.scores;
      if (scores === 0) {
        this.showMessageAboutBlockAction = true;
      }
      BasketModel.getFutureLoyaltyScores(
        clientId,
        discount,
        scores,
        this.setLoyaltyScores,
        this.setError
      );
    }

    this.arItems = result.data;
    this.rootStore?.componentBasketCountStore.init();
  };
  @action
  setLoyaltyScores = (result: any) => {
    if (result && result.data && result.data[0]) {
      this.futureScores = result.data[0].scores;
    }
  };

  getCount = (item: any) => {
    return item?.basket?.count
      ? item?.basket?.count
      : this.getMultiplicityCount(item);
  };

  getMultiplicityCount = (item: any) => {
    let multiplicity = 1;
    if (item?.propsNoFilter?.multiplicity > 1) {
      multiplicity = parseInt(item.propsNoFilter?.multiplicity);
    }
    return multiplicity;
  };

  @action
  setError = (error: any) => {
    console.log(String(error));
  };

  @action
  saveOrder = () => {
    if (window.confirm("Сохранить заказ как черновик?")) {
      this.scores = 0;
      let ob = this.getObOrder();
      OrderModel.addOrder(
        { ...ob, status: enumOrderStatus.draft },
        this.setOrderSave,
        this.setError
      );
    }
  };

  @action setBaseSave = () => {
    this.rootStore?.componentBasketCountStore.init();
    this.init();
    this.arItems = [];
    this.summAll = 0;
  };

  @action
  setOrderSave = () => {
    this.setBaseSave();
    this.rootStore?.mainStore.setRedirectUrl("/order");
  };

  @action
  setOrderSend = (result: any) => {
    this.rootStore?.mainStore.getLoyaltyUpdateInfo();
    // обновляем корзину
    this.rootStore?.componentBasketCountStore.init();
    if (
      result.data.url &&
      result.data.url.data &&
      this.selectedOption.Payment.value === 7
    ) {
      this.linkWebPay = result.data.url.data.redirectUrl;
    } else {
      console.log("успешно отправлено");
    }

    // this.setBaseSave();
    // this.rootStore?.mainStore.setRedirectUrl('/basket-successful');
  };
  @action
  redirectSetOrderSend = () => {
    this.setBaseSave();
    this.rootStore?.mainStore.setRedirectUrl("/basket-successful");
  };

  getOpenModal2() {
    let modal = false;
    let thisDay = new Date();
    if (this.selectedOption.Dates.value) {
      let dateSelected = new Date(this.selectedOption.Dates.value);
      let timeDiff = Math.abs(dateSelected.getTime() - thisDay.getTime());
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays > 5) {
        modal = true;
      }
    }
    return modal;
  }

  @action
  sendOrder = (isModal: boolean) => {
    this.textAboutErrorWebPayLink = false;
    // let dateconfirmpersonaldata = this.rootStore?.mainStore.getDateConfirmPersonalData();
    //
    // if (dateconfirmpersonaldata === null) {
    //     this.rootStore?.mainStore.setOpenConfirmConsent()
    //     // this.openConfirm = true
    //     return false;
    // }
    if (this.selectedOption.Payment.value === 7 && this.summAll < 5) {
      this.openWebPayModalWindowAboutTotalSum = true;
      return false;
    }
    if (!this.isValid()) {
      return false;
    }
    if (isModal) {
      if (this.getOpenModal2()) {
        this.isModalOpen2 = true;
        return false;
      }
      if (
        this.rootStore?.mainStore.user.siteId !== 3 &&
        this.selectedOption.Points.amount > this.summAll
      ) {
        this.isModalOpen = true;
      }
    } else {
      this.isModalOpen = false;
    }
    if (
      this.selectedOption.Dates.value &&
      this.selectedOption.Points.value &&
      this.selectedOption.PaymentType.value &&
      !this.isModalOpen &&
      !this.isModalOpen2
    ) {
      let ob = this.getObOrder();
      if (this.selectedOption.Payment.value === 7) {
        this.openWebPayModalWindow = true;
      } else {
        this.isModalOpen3 = true;
      }

      console.log(ob);
      OrderModel.addOrder(
        { ...ob, status: enumOrderStatus.created },
        this.setOrderSend,
        this.setErrorAlert
      );
    }
  };

  isValid() {
    let result = true;
    if (!this.selectedOption.Dates.value) {
      alert("Выберите дату доставки!");
      result = false;
    }
    if (!this.selectedOption.Points.value) {
      alert("Выберите торговую точку!");
      result = false;
    }
    if (!this.selectedOption.PaymentType.value) {
      alert("Выберите тип оплаты!");
      result = false;
    }
    if (
      this.selectedOption.DeliveryType.value ===
        APP_DELIVERY_CODE_SELF_EXPORT &&
      !this.selectedOption.DeliverySelf.value && 
      this.rootStore?.mainStore.selectedClient.label !== "СОТРУДНИК ОФИСА" &&
      this.rootStore?.mainStore.user?.siteId === 1
    ) {
      alert("Выберите условия самовывоза!");
      result = false;
    }

    if (
      this.selectedOption.DeliveryType.value ===
        APP_DELIVERY_CODE_SELF_EXPORT &&
      this.selectedOption.DeliverySelf.value === 2 &&
      this.pickupFileLink === null &&
      this.rootStore?.mainStore.user?.siteId === 1
    ) {
      alert("Загрузите доверенность!");
      result = false;
    }

    return result;
  }

  getObOrder = () => {
    let clientId = this.rootStore?.mainStore.getClientId();
    return {
      blockReason: "",
      clientId: clientId,
      deliveryTimeFrom: "08:00:00",
      deliveryTimeTo: "16:00:00",
      deliveryTypeId: this.selectedOption.DeliveryType.value,
      ex_id: uuidv4(),
      isProcessed: false,
      // note:'',
      notJoin: false,
      orderSum: this.summAll,
      scaleDiscountByPaymentDateId: this.selectedOption.PaymentType.value,
      shipDate: this.selectedOption.Dates.value,
      siteId: this.rootStore?.mainStore?.user?.siteId,
      status: enumOrderStatus.created,
      tradePointId: this.selectedOption.Points.value,
      userId: this.rootStore?.mainStore.user.id,
      isReturn: false,
      formOfPayment: this.selectedOption.Payment.value,
      paymentType: this.selectedOption.Payment.value,
      scoresDebt: this.scores,
      accountabilityFormId:APP_DELIVERY_CODE_SELF_EXPORT === this.selectedOption.DeliveryType.value ? this.selectedOption.DeliveryInvoices.value:null, 
      pickupFileLink: this.pickupFileLink,
      pickupType: this.pickupType,
      bonusAmount: this.scores
    };
  };

  @action
  onCloseModal = () => {
    this.isModalOpen = false;
  };

  @action
  onCloseModal2 = () => {
    this.isModalOpen2 = false;
  };
  @action
  onCloseModal3 = () => {
    this.isModalOpen3 = false;
    this.redirectSetOrderSend();
  };
  @action
  setCloseWebPayModalWindow = () => {
    this.openWebPayModalWindow = false;
    this.arItems = [];
    this.summAll = 0;
    // this.linkWebPay = ""
  };
  @action
  setCloseWebPayModalWindowTotalSum = () => {
    this.openWebPayModalWindowAboutTotalSum = false;
  };

  @action
  setErrorAlert = (error: any) => {
    let m = "";
    if (
      error !== undefined &&
      error.response !== undefined &&
      error.response.data !== undefined &&
      error.response.data.message !== undefined &&
      error.response.data.message === "Сумма заказа для оплаты 0"
    ) {
      this.arItems = [];
      this.summAll = 0;
      this.linkWebPay = "";
      this.textAboutErrorWebPayLink = true;
      // this.openWebPayModalWindow = true
      // m = String(error.response.data.message);
    } else if (
      error !== undefined &&
      error.response !== undefined &&
      error.response.data !== undefined &&
      error.response.data.message !== undefined &&
      error.response.data.message === "Сумма заказа изменилась"
    ) {
      this.openWebPayModalWindowAboutRedirect = true;
      window.localStorage.setItem("order", "1");
      document.location.href = "/order";
      this.onTextAboutErrorWebPayLink();
    } else if (
      error !== undefined &&
      error.response !== undefined &&
      error.response.data !== undefined &&
      error.response.data.message !== undefined &&
      error.response.data.message === "Сумма заказа для оплаты меньше 5 BYN"
    ) {
      this.arItems = [];
      this.summAll = 0;
      this.linkWebPay = "";
      this.openWebPayModalWindowAboutTotalSum = true;
    } else {
      m = String(error);
      console.log(m);
    }

    this.defaultDate();
    DeliveryModel.getDates(
      0,
      APP_DELIVERY_CODE_SELF_EXPORT,
      this.setDates,
      this.setError
    );
  };

  @action
  onTextAboutErrorWebPayLink = () => {
    this.textAboutErrorWebPayLink = true;
  };

  @action
  onDrop = (files: any) => {
    let clientId = this.rootStore?.mainStore.getClientId();
    this.files = files;
    let file = files[0];
    let formData = new FormData();
    formData.append("file", file);
    s3Model.uploadFileAttorney(
      clientId,
      formData,
      (result: any) => {
        this.pickupFileLink = result?.data?.link;
      },
      (error: any) => {
        if (
          error !== undefined &&
          error.response !== undefined &&
          error.response.data !== undefined &&
          error.response.data.message !== undefined
        ) {
          alert(String(error.response.data.message));
        } else {
          alert(String(error));
        }
      }
    );
  };
}
